<template>
  <section id="dashboard" class="adminPanel">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" class="mb-4">
          <mdb-row class>
            <mdb-col xl="3" md="6" class>
              <mdb-card>
                <mdb-card-body>
                  <div class="d-flex">
                    <mdb-icon icon="user-alt" class="round float-left bg-purple" />
                    <div class>
                      <p class="mb-0">
                        Total Users
                        <span v-if="false" class="text-green">
                          <mdb-icon :icon="newThisMonthIcon" />
                          {{newThisMonthPercent}}
                        </span>
                      </p>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalUsers.number}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>

            <mdb-col xl="3" md="6" class>
              <mdb-card>
                <mdb-card-body>
                  <div class="d-flex">
                    <mdb-icon icon="user-plus" class="round float-left bg-blue" />
                    <div class>
                      <p class="mb-0">
                        New this month
                        <span class="text-green">
                          <mdb-icon :icon="newThisMonthIcon" />
                          {{newThisMonthPercent}}%
                        </span>
                      </p>
                      <h5 class="big-number mb-0 mr-3 float-left" :title="newThisMonth.inprevmonth">
                        <strong>{{newThisMonth.number}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
            <mdb-col xl="3" md="6" class>
              <mdb-card>
                <mdb-card-body>
                  <div class="d-flex">
                    <mdb-icon icon="credit-card" class="round float-left bg-green" />
                    <div class>
                      <p class="mb-0">
                        Total paid
                        <span class="text-green">
                          <mdb-icon icon="long-arrow-alt-up" />4%
                        </span>
                      </p>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>0</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
            <mdb-col xl="3" md="6" class>
              <mdb-card>
                <mdb-card-body>
                  <div class="d-flex">
                    <mdb-icon icon="lock-open" class="round float-left bg-yellow" />
                    <div class>
                      <p class="mb-0">
                        Total free
                        <span class="text-green">
                          <mdb-icon icon="long-arrow-alt-up" />4%
                        </span>
                      </p>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>13</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-card-body>
              </mdb-card>
            </mdb-col>
          </mdb-row>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container>
      <mdb-row class>
        <mdb-col md="6" class="mb-4">
          <mdb-card>
            <h4 class="mb-0">New users</h4>
            <p>Calculated this year</p>
            <mdb-card-body>
              <div style="display: block">
                <mdb-line-chart
                  id="new-users"
                  :data="barChartDataNewUsersComputed"
                  :options="barChartOptions"
                  :height="250"
                  :key="newUsersChartKeyToRerender"
                  ref="newUsersChart"
                />
                <button v-if="false" @click="forceRerenderNewUsersChart">Rerender magic</button>
              </div>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
        <mdb-col md="6" class="mb-4">
          <mdb-card class>
            <h4 class="mb-0">Returning users</h4>
            <p>Calculated this year</p>
            <mdb-card-body>
              <div style="display: block">
                <mdb-line-chart
                  :key="returningUsersChartKeyToRerender"
                  :data="lineChartDataReturningUsers"
                  :options="lineChartOptions"
                  :height="250"
                />
              </div>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container>
      <mdb-row class>
        <mdb-col col="12" class="mb-4">
          <mdb-card>
            <h4 class="mb-0">Assessments</h4>
            <p>Calculated this year</p>
            <mdb-card-body>
              <mdb-row class>
                <mdb-col xl="6" md="6">
                  <div style="display: block">
                    <mdb-line-chart
                      :data="lineChartDataAssessments"
                      :options="lineChartOptions"
                      :height="250"
                      :key="assessmentsChartKeyToRerender"
                    />
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Started</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalAssessments.started}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Finished</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalAssessments.finished}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon far icon="star" />
                    <p class="mb-0">Average Score</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalAssessments.averagescore}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container>
      <mdb-row class>
        <mdb-col col="12" class="mb-4">
          <mdb-card>
            <h4 class="mb-0">Videos</h4>
            <p>Calculated this year</p>
            <mdb-card-body>
              <mdb-row class>
                <mdb-col xl="6" md="6">
                  <div style="display: block">
                    <mdb-line-chart
                      :data="lineChartDataVideos"
                      :options="lineChartOptions"
                      :height="250"
                      :key="videosChartKeyToRerender"
                    />
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Started</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalVideos.started}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Finished</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalVideos.finished}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon far icon="star" />
                    <p class="mb-0">Average Score</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>??</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-container>
      <mdb-row class>
        <mdb-col col="12" class="mb-4">
          <mdb-card>
            <h4 class="mb-0">Courses</h4>
            <p>Calculated this year</p>
            <mdb-card-body>
              <mdb-row class>
                <mdb-col xl="6" md="6">
                  <div style="display: block">
                    <mdb-line-chart
                      :data="lineChartDataCourses"
                      :options="lineChartOptions"
                      :height="250"
                      :key="coursesChartKeyToRerender"
                    />
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Started</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalCourses.started}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon icon="sign-in-alt" />
                    <p class="mb-0">Total Finished</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>{{totalCourses.finished}}</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
                <mdb-col xl="2" md="6" class="flex-center">
                  <div>
                    <mdb-icon far icon="star" />
                    <p class="mb-0">Average Score</p>
                    <div class>
                      <h5 class="big-number mb-0 mr-3 float-left">
                        <strong>??</strong>
                      </h5>
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardText,
  mdbCardFooter,
  mdbIcon,
  mdbTbl,
  mdbBarChart,
  mdbPieChart,
  mdbLineChart,
  mdbRadarChart,
  mdbDoughnutChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbBadge,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";
import { statsMixin } from "../mixins/StatsMixin";
import LineChartUsingChartJsExtender from "../components/LineChartUsingChartJsExtender.vue";

export default {
  name: "AdminDashboard",
  mixins: [statsMixin],
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardText,
    mdbCardFooter,
    mdbIcon,
    mdbTbl,
    mdbBarChart,
    mdbPieChart,
    mdbLineChart,
    mdbRadarChart,
    mdbDoughnutChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbBadge,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    LineChartUsingChartJsExtender
  },

  data() {
    return {
      barChartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              barPercentage: 1,
              gridLines: {
                display: false,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(0, 0, 0, 0.1)"
              },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      pieChartData: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
        datasets: [
          {
            data: [300, 50, 100, 40, 120, 24, 52],
            backgroundColor: [
              "#F7464A",
              "#46BFBD",
              "#FDB45C",
              "#949FB1",
              "#4D5360",
              "#ac64ad"
            ],
            hoverBackgroundColor: [
              "#FF5A5E",
              "#5AD3D1",
              "#FFC870",
              "#A8B3C5",
              "#616774",
              "#da92db"
            ]
          }
        ]
      },
      pieChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      lineChartData: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Now",
          "Dec"
        ],
        datasets: [
          {
            label: "",
            backgroundColor: "rgba(85, 66, 251, 1)",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      lineChartOptions: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ]
        }
      },
      radarChartData: {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
        datasets: [
          {
            label: "#1",
            backgroundColor: "rgba(245, 74, 85, 0.5)",
            data: [65, 59, 80, 81, 56, 55, 40]
          },
          {
            label: "#2",
            backgroundColor: "rgba(90, 173, 246, 0.5)",
            data: [12, 42, 121, 56, 24, 12, 2]
          },
          {
            label: "#3",
            backgroundColor: "rgba(245, 192, 50, 0.5)",
            data: [2, 123, 154, 76, 54, 23, 5]
          }
        ]
      },
      radarChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      doughnutChartData: {
        labels: ["Red", "Green", "Yellow", "Grey", "Dark Grey"],
        datasets: [
          {
            data: [300, 50, 100, 40, 120],
            backgroundColor: [
              "#F7464A",
              "#46BFBD",
              "#FDB45C",
              "#949FB1",
              "#4D5360"
            ],
            hoverBackgroundColor: [
              "#FF5A5E",
              "#5AD3D1",
              "#FFC870",
              "#A8B3C5",
              "#616774"
            ]
          }
        ]
      },
      doughnutChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },

  mounted() {
    this.mthMixinFillNewUsersStatsDataSource();

    this.mthMixinFillAssessmentsDataSource();

    this.mthMixinFillVideosAndCoursesDataSource();

    this.mthMixinFillReturningUsersDataSource();

    //this.mthMixinFillTotalAssessmentFinished();

    this.mthMixinSetNewThisMonth();

    let chart = window.document.getElementsByTagName("canvas")[0];
    console.log(this.$refs.newUsersChart);
  }
};
</script>

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
